import { render, staticRenderFns } from "./ManageCategory.vue?vue&type=template&id=bcc4a0be&scoped=true&"
import script from "./ManageCategory.vue?vue&type=script&lang=js&"
export * from "./ManageCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc4a0be",
  null
  
)

export default component.exports